import { Editor } from "minimals-template/components/editor"
import { bind } from "lib/@components/binding/bind"
import { FULL_SCREEN_BTN } from "minimals-template/components/editor/editor-buttons"

export function AuthoringEditor({ addBtns = [], ...props }) {
    return <Editor {...props} addBtns={[...addBtns, FULL_SCREEN_BTN]} />
}

export const AuthoringBoundTextEditor = bind(<AuthoringEditor />, { extract: (v) => v })
